export const FACTORY_ADDRESS = '0xa22F8cf50D9827Daef24dCb5BAC92C147a9D342e'

export const INIT_CODE_HASH = '0x6c57ed802dc5d4d6ce04dc39f66e6d2a6cebf8b7efbc068ce7b0419f5ee4ade1'

export const ROUTER_ADDRESS = '0x0A8015b1647bc133F25681da0996307839eD64FD'
